import React, { useState, useMemo } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const TourSelector = ({ tours, selectedTourId, onTourSelect, disabled = false, placeholder = "בחר סיור" }) => {
  const [search, setSearch] = useState('');

  const filteredTours = useMemo(() => {
    if (!search.trim()) return tours;
    const q = search.toLowerCase();
    return tours.filter(t => t.name?.toLowerCase().includes(q) || t.id?.toLowerCase().includes(q));
  }, [tours, search]);

  return (
    <div className="flex flex-col gap-2">
      <input
        type="text"
        placeholder="חיפוש סיור..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      />
      <Select
        value={selectedTourId || ''}
        onValueChange={onTourSelect}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {filteredTours.map(tour => (
            <SelectItem key={tour.id} value={tour.id}>
              {tour.name}
            </SelectItem>
          ))}
          {filteredTours.length === 0 && (
            <div className="p-2 text-sm text-muted-foreground text-center">לא נמצאו סיורים</div>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TourSelector;
